<template>
	<div>
		<div class="font-16 font-weight-bold grey--text text--darken-1 mt-7 mb-3">Członkowie grup</div>
		<search />
		<template v-if="!refresh">
			<div v-for="(userMember, i) in users" :key="'group-user-' + i" class="mt-5">
				<v-divider v-if="i > 0" class="mb-5" />
				<group-form-member :editable="editable" :user-member="userMember" />
			</div>
		</template>
		<v-pagination
			v-if="meta && meta.last_page > 1"
			class="mt-4"
			:length="meta.last_page"
			:total-visible="meta.total"
			@change="changePage()"
			@input="changePage()"
			color="primary"
			v-model="meta.current_page"
		>
		</v-pagination>
		<template v-if="requests && requests.length > 0">
			<div class="font-16 font-weight-bold grey--text text--darken-1 mt-7 mb-3 mt-3">Prośby o dołączenie</div>
			<template v-if="!refresh">
				<div v-for="(userRequest, i) in requests" :key="'group-request-user-' + i" class="mt-5">
					<v-divider v-if="i > 0" class="mb-5" />
					<group-form-member request :user-member="{ user: userRequest}" />
				</div>
			</template>
			<v-pagination
				v-if="requestsMeta && requestsMeta.last_page > 1"
				class="mt-4"
				:length="requestsMeta.last_page"
				:total-visible="requestsMeta.total"
				@change="requestsChangePage()"
				@input="requestsChangePage()"
				color="primary"
				v-model="requestsMeta.current_page"
			>
			</v-pagination>
		</template>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Search from "@/components/top-bar/Search";
import GroupFormMember from "@/components/group/GroupFormMember";

export default {
	name: "GroupFormMembers",
	components: {
		Search,
		GroupFormMember,
	},
	props: {
		editable: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			refresh: false
		}
	},
	computed: {
		...mapGetters({
			users: "groups/users",
			meta: "groups/usersMeta",
			requests: "groups/groupRequests",
			requestsMeta: "groups/groupRequestsMeta",
		}),
	},
	created() {
		this.getUsers({})
	},
	methods: {
		...mapActions('groups', [
			'getUsers',
			'getGroupRequests'
		]),
		async changePage() {
			let params = {
				page: this.meta.current_page
			}
			await this.getUsers({ params : params })
			this.refresh = true
			this.$nextTick(() => {
				this.refresh = false
			})
		},
		async requestChangePage() {
			let params = {
				page: this.meta.current_page
			}
			await this.getGroupRequests({ params : params })
			this.refresh = true
			this.$nextTick(() => {
				this.refresh = false
			})
		}
	}
}
</script>
